import { useState, useContext } from "react";
import { GlobalContext } from "../../Context/GlobalContext";

function useUser() {
  const { api } = useContext(GlobalContext);

  const [people, setPeople] = useState([]);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);

  // Invite User
  const inviteUser = async (payload) => {
    try {
      const res = await api.post("/User/inviteUserV1", payload);
      return res.data;
    } catch (error) {
      console.error("inviteUser error:", error);
      return null;
    }
  };

  // Get Delivery Locations for State Dropdown
  const getDeliveryLocations = async (userid = "") => {
    try {
      const res = await api.post("/Delivery/getDeliveryLocationBhandarewala", {
        userid: String(userid ?? ""),
      });

      return res.data;
    } catch (error) {
      console.error("getDeliveryLocations error:", error);
      return null;
    }
  };

  // Get Roles
  const getUserRoles = async (userID) => {
    try {
      const res = await api.post("/User/getUserRoles", {
        userid: userID,
      });

      const data = res.data;

      if (data?.responseCode === "00") {
        setRoles(data?.response);
      }

      return data;
    } catch (error) {
      console.error("getUserRoles error:", error);
      return null;
    }
  };

  // Change Status
  const changeUserStatus = async (payload) => {
    try {
      const res = await api.post("/User/changeUserStatus", payload);
      return res.data;
    } catch (error) {
      console.error("changeUserStatus error:", error);
      return null;
    }
  };

  // Delete User
  const deleteUser = async (payload) => {
    try {
      const res = await api.post("/User/deleteUser", payload);
      return res.data;
    } catch (error) {
      console.error("deleteUser error:", error);
      return null;
    }
  };

  // Generate / Save POS Drawer PIN
  const generatePosDrawerPin = async (payload) => {
    try {
      const res = await api.post("/Order/generatePosDrawerPin", payload);

      return res.data;
    } catch (error) {
      console.error("generatePosDrawerPin error:", error);
      return null;
    }
  };

  // Get POS Drawer PIN
  const getPOSAccessPin = async (payload) => {
    try {
      const res = await api.post("/Order/getPOSAccessPin", payload);

      return res.data;
    } catch (error) {
      console.error("getPOSAccessPin error:", error);
      return null;
    }
  };

  return {
    loading,
    people,
    roles,
    getDeliveryLocations,
    generatePosDrawerPin,
    getPOSAccessPin,
    inviteUser,
    getUserRoles,
    changeUserStatus,
    deleteUser,
  };
}

export default useUser;